// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3JSby","label":"LabeledBox_label__3YBkV"};